import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, tap } from 'rxjs';
import { isPlatformBrowser } from '@angular/common';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class LoginService {
    private apiUrl = environment.baseUrl;

    constructor(
        private http: HttpClient,
        @Inject(PLATFORM_ID) private platformId: Object
    ) {}

    login(phone: string, password: string): Observable<any> {
        return this.http.post(`${this.apiUrl}/user/login`, { phone, password }).pipe(
            tap((response: any) => {
                if (response.returncode === '300' && response?.data?.token) {
                    this.saveAuthData(response.data);
                }
            })
        );
    }

    saveAuthData(data: any): void {
        if (isPlatformBrowser(this.platformId)) {
            localStorage.setItem('auth_token', data.token);
            if (data.user) {
                localStorage.setItem('auth_user', JSON.stringify(data.user));
            }
        }
    }

    getToken(): string | null {
        if (isPlatformBrowser(this.platformId)) {
            return localStorage.getItem('auth_token');
        }
        return null;
    }

    getUser(): any {
        if (isPlatformBrowser(this.platformId)) {
            const userStr = localStorage.getItem('auth_user');
            if (userStr) {
                try {
                    return JSON.parse(userStr);
                } catch (e) {
                    return null;
                }
            }
        }
        return null;
    }

    refreshToken(): Observable<any> {
        const user = this.getUser();
        const token = this.getToken();

        return this.http.post(`${this.apiUrl}/user/refreshtoken`, {
            id: user?.id,
            token: token
        }).pipe(
            tap((response: any) => {
                if (response?.data?.token) {
                    this.saveAuthData(response.data);
                }
            })
        );
    }

    logout(): void {
        if (isPlatformBrowser(this.platformId)) {
            localStorage.removeItem('auth_token');
            localStorage.removeItem('auth_user');
        }
    }
}